import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

export interface ModalNoticeDialogData {
    titulo?: string;
    subtitulo?: string;
    videoUrl?: string;
}

@Component({
    selector: 'app-modal-notice-dialog',
    standalone: true,
    imports: [MatIcon, CommonModule],
    templateUrl: './modal-notice-dialog.component.html',
    styleUrl: './modal-notice-dialog.component.scss',
})
export class ModalNoticeDialogComponent {
    public titulo = '';
    public subtitulo = '';
    public videoUrl: SafeResourceUrl | null = null;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ModalNoticeDialogData,
        private dialogRef: MatDialogRef<ModalNoticeDialogComponent>,
        private sanitizer: DomSanitizer,
    ) {
        if (data.titulo) {
            this.titulo = data.titulo;
        }
        if (data.subtitulo) {
            this.subtitulo = data.subtitulo;
        }
        if (data.videoUrl) {
            this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.videoUrl);
        } else {
            // Fallback default if needed, or keep null
            this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                'https://www.youtube.com/embed/NJZtb1QNO1k?si=E8iMD9ZD4KuuSmHw',
            );
        }
    }

    public fechar() {
        this.dialogRef.close();
    }
}
